import React, { useContext, useEffect, useState } from 'react';
import {Button, Form, message, Typography} from 'antd';
import { useForm } from 'antd/es/form/Form';
import { UserInfoContext } from '../index';
import useCreateUser from '../../../../api/auth/auth-hooks';
import { ReactComponent as Logo } from '../../../../assets/check.svg';
import { PhoneInput,  defaultCountries, parseCountry,} from 'react-international-phone';
import 'react-international-phone/style.css';
import {isValidPhone} from "../../../../utils/valid-phone";

message.config({
    top: 40,
});

const FirstStep = ({ setIsNext, translation }) => {
    const [form] = useForm();
    const context = useContext(UserInfoContext);
    const { mutate } = useCreateUser(setIsNext);
    const [phoneError, setPhoneError] = useState('');
    const [isBuyer, setIsBuyer] = useState(false);
    useEffect(() => {
        form.setFieldsValue({ phoneNumber: '+7' });
    }, [form]);

    const onNext = () => {
        const phoneNumber = form.getFieldValue('phoneNumber');

        if (!isValidPhone(phoneNumber)) {
            setPhoneError('Неверный номер телефона');
            return;
        }

        const formattedPhoneNumber = phoneNumber.replace('+', '');

        // Установка пользователя в контексте
        context.setUser({
            username: '',
            phone: formattedPhoneNumber,
            password: '',
            smsCode: '',
            cityId: '',
            filialId: '',
            address: '',
            house: '',
        });

        if (!isBuyer) {
            mutate({
                username: '',
                email: '',
                fullName: '',
                lastName: '',
                phone: formattedPhoneNumber,
                password: '',
                cityId: '',
                filialId: '',
                smsCode: '',
                address: '',
                house: '',
            });
        }
        setIsNext(isBuyer ? 'password' : 'smsCode');
    };
    const handleBuyerChange = (e) => {
        setIsBuyer(e.target.checked);
    };
    const countries = defaultCountries.filter((country) => {
        const { iso2 } = parseCountry(country);
        return ['kz', 'kg'].includes(iso2);
    });
    return (
        <>
            <Typography.Title style={{ color: 'white', fontWeight: '400' }} level={3}>
                {translation('register')}
            </Typography.Title>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
                <p style={{ fontFamily: 'Roboto, san-serif', fontSize: '14px', color: 'white' }}>
                    Байер
                </p>
                <input type={'checkbox'} onChange={handleBuyerChange} checked={isBuyer} />
            </div>
            <Form style={{ color: 'white' }} layout="vertical" form={form}>
                <Form.Item
                    label={<Typography.Text style={{ color: 'white' }}>Телефон</Typography.Text>}
                    name="phoneNumber"
                >
                    <PhoneInput
                        defaultCountry="kz"
                        value={form.getFieldValue('phoneNumber') || ''}
                        onChange={(value) => {
                            form.setFieldsValue({ phoneNumber: value });
                            setPhoneError('');
                        }}
                        className="register-input"
                        style={
                            {
                                padding: '7px 20px',
                                '--react-international-phone-font-size': '16px',
                            }
                        }
                        countries={countries}
                    />                    
                </Form.Item>
                {phoneError && (
                    <Typography.Text style={{ color: 'red', fontSize: '12px' }}>
                        {phoneError}
                    </Typography.Text>
                )}
                <div className={'logo-div'}>
                    <Logo width={'100%'} height={'100%'} />
                </div>
                <Button
                    style={{
                        width: '100%',
                        height: '52px',
                        backgroundColor: 'white',
                    }}
                    onClick={onNext}
                >
                    <Typography.Text style={{ color: '#100E71', fontWeight: '500' }}>
                        {translation('continue')}
                    </Typography.Text>
                </Button>
            </Form>
        </>
    );
};
export default FirstStep;
